/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationMembershipSchema } from './OrganizationMembershipSchema';
import {
    OrganizationMembershipSchemaFromJSON,
    OrganizationMembershipSchemaFromJSONTyped,
    OrganizationMembershipSchemaToJSON,
} from './OrganizationMembershipSchema';

/**
 * 
 * @export
 * @interface PagedOrganizationMembershipSchema
 */
export interface PagedOrganizationMembershipSchema {
    /**
     * 
     * @type {Array<OrganizationMembershipSchema>}
     * @memberof PagedOrganizationMembershipSchema
     */
    items: Array<OrganizationMembershipSchema>;
    /**
     * 
     * @type {number}
     * @memberof PagedOrganizationMembershipSchema
     */
    count: number;
}

/**
 * Check if a given object implements the PagedOrganizationMembershipSchema interface.
 */
export function instanceOfPagedOrganizationMembershipSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedOrganizationMembershipSchemaFromJSON(json: any): PagedOrganizationMembershipSchema {
    return PagedOrganizationMembershipSchemaFromJSONTyped(json, false);
}

export function PagedOrganizationMembershipSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedOrganizationMembershipSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(OrganizationMembershipSchemaFromJSON)),
        'count': json['count'],
    };
}

export function PagedOrganizationMembershipSchemaToJSON(value?: PagedOrganizationMembershipSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(OrganizationMembershipSchemaToJSON)),
        'count': value.count,
    };
}

